import { ref } from 'vue'
import { useMutation } from '@tanstack/vue-query'

import { log } from 'src/services/app/log.service'
import { notifyMsgs, notifyService } from 'src/services/app/notify.service'
import { supportService } from 'src/services/api/support.service'
import { MUTATION_KEYS } from 'src/services/consts/queries.const'
import { EMPTY_SUPPORT_FORM } from 'src/services/consts/support.const'
import { wrapMutationAsync } from 'src/services/helpers/util.helper'

// Modal state (singleton - shared across all components)
const isSupportModalOpen = ref(false)
const supportFormData = ref({ ...EMPTY_SUPPORT_FORM })

function resetSupportForm() {
  supportFormData.value = { ...EMPTY_SUPPORT_FORM }
}

export function useSupportModal() {
  return {
    isSupportModalOpen,
    supportFormData,
    openSupportModal: (formData) => {
      resetSupportForm()
      if (formData) {
        supportFormData.value = { ...EMPTY_SUPPORT_FORM, ...formData }
      }
      isSupportModalOpen.value = true
    },
    closeSupportModal: () => {
      isSupportModalOpen.value = false
      resetSupportForm()
    },
    resetSupportForm,
  }
}

export function useSubmitSupportMutation() {
  const submitSupportMutation = useMutation({
    mutationKey: [MUTATION_KEYS.SUBMIT_SUPPORT],
    mutationFn: async ({ topic, message }) => {
      return supportService.submitSupportRequest({
        topic,
        message,
      })
    },
    onSuccess: (response) => {
      log.info('[Support] Request submitted successfully', response)
      notifyService.success(notifyMsgs.success.supportRequestSubmitted)
    },
    onError: (error) => {
      log.error('[Support] Failed to submit support request', error)
      notifyService.error(notifyMsgs.error.failedSubmitSupport)
    },
  })

  return {
    submitSupport: wrapMutationAsync(submitSupportMutation.mutateAsync),
    isSubmitting: submitSupportMutation.isPending,
  }
}
